


import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {TractorBeamParsedGameData} from "../../server/data/TractorBeamParsedGameData";

export class TractorBeamSpinController extends SpinController {

    private _stackedTriggered:boolean;

    constructor() {
        super();

        //EventHandler.addLastEventListener(this, SpinEvent.STOP, (event:GameEvent) => this.onForceNoStop());
    }

    protected parseGameData(data: ParsedServerData): void {
        const tractorData:TractorBeamParsedGameData = <TractorBeamParsedGameData> data;

        this._stackedTriggered = tractorData.randomStackedTriggered;

        if(super.parseGameData) {
            super.parseGameData(data);
        }
    }

    /*protected onAllReelsSpinStarted():void {
        super.onAllReelsSpinStarted();
    }*/

    protected onAllReelsSpinStarted():void {
        // Tells the api
        //EventHandler.dispatchEvent(new GameEvent(SpinEvent.STARTED));
        this.addStopDelay(this.getSpinTime());
        this.onSpinTimerDone();
    }

    protected onSpinTimerDone():void {
        super.onSpinTimerDone();
    }

    protected onForceNoStop():void {
        this._isQuickStop = false;
    }

    /*protected getSpinTime():number {
        return 5;
    }*/

}
